import { ReportTemplate } from './ReportTemplate'

export class ReportTemplateMORegionReportByRegNumb extends ReportTemplate {
	constructor(...args) {
		super(...args)
		this.set(
			'type',
			ReportTemplate.Type.MonitoringObjectsRegionalReportByRegNumber,
		)
	}

	getTimeType() {
		return ReportTemplate.TimeType.None
	}

	static testProperties(properties) {
		return properties.type === ReportTemplate.Type.MonitoringObjectsRegionalReportByRegNumber
	}
}
